import React, { useContext } from 'react';

import { hot } from 'react-hot-loader/root';

import { ShowIntercomContext } from 'common/containers/IntercomContainer';
import OneloginLandingHelmet from 'common/helmets/OneloginLandingHelmet';
import Button from 'common/inputs/Button';
import LandingFooterCTA from 'common/LandingFooterCTA';
import LazyLoadedImage from 'common/LazyLoadedImage';
import OneLoginLogo from 'img/landing/onelogin-logo.webp';

import CannyLogoIcon from 'img/canny-icon.svg';

import 'css/components/integrations/_IntegrationsLanding.scss';
import 'css/components/_LandingFeatures.scss';

const OneloginLanding = () => {
  const showIntercom = useContext(ShowIntercomContext);

  return (
    <div className="integrationsLanding withoutImage">
      <OneloginLandingHelmet />
      <div className="integrationsLandingContainer">
        <div className="header">
          <div className="left">
            <div className="logosCombined">
              <LazyLoadedImage
                className="companyLogo"
                loading="eager"
                src={CannyLogoIcon}
                alt="Canny Logo"
              />
              +
              <LazyLoadedImage
                className="companyLogo"
                loading="eager"
                src={OneLoginLogo}
                alt="Onelogin Logo"
              />
            </div>
            <div className="text">
              <h1 className="title">Canny’s OneLogin SSO and Provisioning Integration</h1>
              <p className="subtitle">
                Let your team log in to Canny with a single click in their OneLogin dashboard.
              </p>
              <div className="links">
                <Button
                  buttonType="blackButton"
                  value="Contact us for access"
                  onTap={showIntercom}
                />
                <a
                  href="https://help.canny.io/en/articles/5087863-onelogin-sso-and-provisioning-integration"
                  rel="noopener"
                  target="_blank"
                  className="LandingIntegrations__install-link">
                  See install docs
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="features">
          <div className="featureHighlight">
            <div className="featureText">
              <h2 className="title">Control Canny access from OneLogin</h2>
              <p className="subtitle">
                Easily manage which team members have Canny access in your OneLogin account. Adding
                and removing access is quick and easy.
              </p>
            </div>
          </div>
          <div className="featureHighlight">
            <div className="featureText">
              <h2 className="title">Provisioning roles made easy</h2>
              <p className="subtitle">
                Automatically set Canny roles for different user groups in OneLogin.
              </p>
            </div>
          </div>
        </div>
        <LandingFooterCTA style="solid" />
      </div>
    </div>
  );
};

export default hot(OneloginLanding);
